import {TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@material-ui/core";
import {CustomTable} from "../token-options-table/TokenOptionsTableStyles";
import TableLoader from "../../../../components/ui/tables/rows/table-loader/TableLoader";
import PropTypes from "prop-types";
import {useSimpleTableStyles} from "./SimpleTableStyles";
import React from "react";

const SimpleTable = (props) => {
    const classes = useSimpleTableStyles()

    return (
        <TableContainer>
            <CustomTable>
                <TableHead>
                    <TableRow className={classes.row}>
                        {props.headCells.map(hc => (
                            <TableCell
                                key={`simple-table-head-cell-${hc.id}`}
                                align="left"
                                width={hc.width}
                            >
                                <Typography variant="overline">{hc.text}</Typography>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody className={classes.row}>
                    {
                        props.loading ? <TableLoader
                                loading={props.loading}
                                colSpan={props.headCells.length}
                            /> :
                            props.tableRows
                    }
                </TableBody>
            </CustomTable>
        </TableContainer>
    )
}

SimpleTable.propTypes = {
    loading: PropTypes.bool,
    tableRows: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    headCells: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            width: PropTypes.string,
            text: PropTypes.string,
        }).isRequired
    ).isRequired
}

SimpleTable.defaultProps = {
    loading: false
}

export default SimpleTable;
